import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

export const SkuMessageInfo = ({ message }: any) => {
    return (
        <Alert variant="info"  className="mx-4 my-4">
            <div  className="text-center">{message}</div>
        </Alert>
    )
}

SkuMessageInfo.propTypes = {
    message: PropTypes.string.isRequired,
}